<template>
  <div>
    <b-row>
      <b-col sm="12">
        <p>
          <strong>O que é Defesa de Autuação ?</strong>
        </p>
        <ul>
          <li class="mb-3">
            É a possibilidade administrativa de pedir que seja reanalisada a
            autuação aplicada e notificada pela Autoridade competente em função
            do cometimento de uma infração de trânsito, tendo este pedido
            alegações e provas com o devido amparo da Lei. A interposição da
            Defesa de Autuação (Defesa Prévia) só pode ser feita dentro do prazo
            limite estipulado, após a Notificação de Autuação e antes que tenha
            sido emitida a Notificação de Penalidade.
          </li>
        </ul>
      </b-col>
    </b-row>
    <hr />
    <b-row v-if="!auto_infracao_transito.isCancelado()">
      <b-col cols="4">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Prazo Identificação Condutor Infrator - FICI&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="FICI - Identificação do Condutor Infrator"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(auto_infracao_transito.prazo_fici)) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group
          label="Prazo Entrada de Defesa de Autuação"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(auto_infracao_transito.prazo_defesa)) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-overlay :show="showmanowanderley" rounded="sm">
      <b-card no-body class="mb-3">
        <b-card-header
          header-bg-variant="outline-secondary"
          header-tag="header"
          class="p-0"
          role="tab"
        >
          <h6 class="mb-0 p-1 titulo_ait" align="left">Defesa de Autuação</h6>
        </b-card-header>
        <div class="p-3" v-if="listaDefesa.length == 0">
          <em
            >Não houve Interposição de Defesa de Autuação para esse auto de
            infração</em
          >
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <b-table
                stacked="sm"
                show-empty
                small
                striped
                bordered
                :sticky-header="true"
                :no-border-collapse="false"
                responsive
                :fields="fieldsDetail"
                :items="listaDefesa"
              >
                <template v-slot:empty>
                  Não existem valores cadastrados
                </template>

                <template v-slot:cell(numero_processo)="data">
                  {{ temValor(data.item.numero_processo) }}/{{
                    temValor(data.item.ano_processo)
                  }}
                </template>

                <template v-slot:cell(situacao)="data">
                  {{ temValor(data.item.status_processo.descricao) }}
                </template>

                <template v-slot:cell(decisao)="data">
                  {{ temValor(data.item.decisao_processo.descricao) }}
                </template>

                <template v-slot:cell(data_solicitacao_considerada)="data">
                  {{
                    temValor(dataBrasil(data.item.data_solicitacao_considerada))
                  }}
                </template>

                <template v-slot:cell(data_resultado)="data">
                  {{ temValor(dataBrasil(data.item.data_resultado)) }}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col v-if="listaDefesa.length > 0">
            <em style="font-size: small">
              <b-link
                size="sm"
                class="text-primary"
                target="_blank"
                href="https://servicos.pbh.gov.br/servicos/my-requests"
                title="Protocolo do Portal de Serviços da PBH - Acompanhe sua solicitação"
              >
                * Protocolo do Portal de Serviços da PBH - Acompanhe sua
                solicitação
              </b-link></em
            >
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
    <b-row class="mt-3">
      <b-col>
        <font-awesome-icon
          size="lg"
          :icon="['fa', 'circle-info']"
          class="mr-1"
        />
        <u><strong>Serviços oferecidos no Portal de Serviços da PBH</strong></u>
      </b-col>
    </b-row>
    <b-card class="mb-2 mt-1" no-body>
      <b-row class="p-2">
        <b-col>
          <b-link
            size="sm"
            class="text-primary"
            style="font-weight: bold"
            target="_blank"
            href="https://servicos.pbh.gov.br/i/5e4d490de1bf5e706b4a6c1f/5dc8470253fd6b5bbd99185f/servicos+defesa-da-autuacao-de-transito"
            title="Serviço FICI - Formulário de Indicação do Condutor Infrator -
              Portal de Serviços PBH"
          >
            <font-awesome-icon
              size="lg"
              :icon="['fa', 'arrow-up-right-from-square']"
            />
            Serviço Defesa de Autuação - Portal de Serviços PBH
          </b-link>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col>
          <p>
            Se deseja apresentar requerimento indicando inconsistências e
            solicitando o cancelamento do Auto de Infração de Trânsito - AIT,
            utilize o serviço específico no Portal de Serviços da PBH.
          </p>
          <p>
            Já abriu sua solicitação? Para mais detalhes sobre sua solicitação
            já aberta, acesse o Portal de Serviços da PBH com os dados do
            protocolo e/ou acesso GovBr (vide Área de Relacionamento)
          </p>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col>
          <b-link
            size="sm"
            class="text-primary"
            style="font-weight: bold"
            target="_blank"
            href="https://servicos.pbh.gov.br/servicos/i/5e7bb0b5d9521a26a9cedfd6/5dc8470253fd6b5bbd99185f/servicos+defesa-da-autuacao-de-transito-vistas-ao-processo"
            title="Serviço Consulta Documentação de Defesa - Portal de Serviços PBH"
          >
            <font-awesome-icon
              size="lg"
              :icon="['fa', 'arrow-up-right-from-square']"
            />
            Serviço Consulta Documentação da Defesa de Autuação - Portal de
            Serviços PBH
          </b-link>
        </b-col>
      </b-row>
      <b-row class="p-2">
        <b-col>
          <p>
            Solicitação para ter acesso ao processo de defesa de autuação após
            julgado.
          </p>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { helperDatas, helperNumeros } from "@/helpers";
import Processo from "@/models/Processo";
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";

export default {
  props: {
    auto_infracao_transito: {
      type: Object,
      default: function () {
        return new AutoInfracaoTransito();
      },
    },
  },

  data() {
    return {
      showmanowanderleyadvertencia: false,
      showmanowanderley: false,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      listaDefesa: [],

      fieldsDetail: [
        { key: "numero_processo", label: "Nº Processo" },
        {
          key: "protocolo_bhdigital",
          label: "Protocolo *",
          thStyle: { width: "160px" },
        },
        { key: "data_solicitacao_considerada", label: "Data Interposição" },
        { key: "situacao", label: "Situação" },
        { key: "decisao", label: "Decisão" },
        { key: "data_resultado", label: "Data Julgamento" },
      ],
    };
  },

  methods: {
    /* */
    recursoDefesa() {
      this.showmanowanderley = true;
      this.$api.Multa.buscarListaDefesa({
        hash: this.auto_infracao_transito.hash,
      })
        .then(async (response) => {
          this.showmanowanderley = false;
          if (response.data.success && response.data.data) {
            if (response.data.data) {
              this.listaDefesa = [];
              response.data.data.listaDefesa.forEach((el) => {
                if (el.status_processo.codigo_status != "4")
                  this.listaDefesa.push(new Processo(el));
              });
            }
          }
        })
        .catch(() => {
          this.showmanowanderley = false;
        });
    },

    temValor(valor) {
      return valor ? valor : "-";
    },
    /* */
    formataReal(vlaor) {
      return helperNumeros.formatReal(vlaor);
    },

    dataBrasil(vlaor) {
      return helperDatas.dataBrasil(vlaor);
    },

    loadInfos() {
      if (!this.carregado) {
        this.recursoDefesa();
        this.carregado = true;
      }
    },
  },
};
</script>


<style scoped>
input .form-control-sm {
  font-weight: 700 !important;
}
.input-group-sm > .form-control {
  font-weight: 700 !important;
}
</style>